module.exports = __webpack_public_path__ + "img/tax_t@2x.2a8a065d.png";